var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('main', {
    staticClass: "financiers-card"
  }, [_c('header', {
    staticClass: "financiers-heading"
  }, [_vm._m(0), _c('button', {
    staticClass: "primary-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.startCreating
    }
  }, [_vm._v(" + Pridať finančníka ")])]), _vm.loading ? _c('div', {
    staticClass: "financiers-state"
  }, [_c('v-progress-circular', {
    staticClass: "loading-spinner small",
    attrs: {
      "indeterminate": ""
    }
  }), _c('span', [_vm._v("Načítavam finančníkov...")])], 1) : _vm.loadError ? _c('div', {
    staticClass: "financiers-state error-state"
  }, [_c('strong', [_vm._v("Finančníkov sa nepodarilo načítať.")]), _c('button', {
    staticClass: "secondary-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.loadData
    }
  }, [_vm._v(" Skúsiť znova ")])]) : _c('div', {
    staticClass: "financiers-workspace"
  }, [_c('aside', {
    staticClass: "financiers-list"
  }, [_c('div', {
    staticClass: "list-toolbar"
  }, [_c('label', [_c('span', [_vm._v("Hľadať")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.search,
      expression: "search",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "search",
      "placeholder": "Meno alebo email"
    },
    domProps: {
      "value": _vm.search
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.search = $event.target.value.trim();
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _c('div', {
    staticClass: "status-filter"
  }, _vm._l(_vm.statusOptions, function (option) {
    return _c('button', {
      key: option.value,
      "class": {
        active: _vm.statusFilter === option.value
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          _vm.statusFilter = option.value;
        }
      }
    }, [_vm._v(" " + _vm._s(option.label) + " ")]);
  }), 0)]), _c('div', {
    staticClass: "list-count"
  }, [_vm._v(" " + _vm._s(_vm.filteredFinanciers.length) + " " + _vm._s(_vm.financierCountLabel(_vm.filteredFinanciers.length)) + " ")]), _c('div', {
    staticClass: "financier-items"
  }, [_vm._l(_vm.filteredFinanciers, function (financier) {
    return _c('button', {
      key: financier.id,
      staticClass: "financier-item",
      "class": {
        active: _vm.selectedId === financier.id && !_vm.creating
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.selectFinancier(financier);
        }
      }
    }, [_c('span', {
      staticClass: "avatar",
      "class": {
        inactive: !financier.is_active
      },
      style: _vm.avatarStyle(financier)
    }, [!financier.profile_image ? _c('span', [_vm._v(" " + _vm._s(_vm.initials(financier)) + " ")]) : _vm._e()]), _c('span', {
      staticClass: "financier-summary"
    }, [_c('strong', [_vm._v(_vm._s(_vm.fullName(financier)))]), _c('small', [_vm._v(_vm._s(financier.email))]), _c('span', {
      staticClass: "summary-meta"
    }, [_c('em', {
      "class": {
        success: financier.is_active
      }
    }, [_vm._v(" " + _vm._s(financier.is_active ? "Aktívny" : "Neaktívny") + " ")]), financier.staff_profile && financier.staff_profile.is_pooled ? _c('em', {
      staticClass: "pooling"
    }, [_vm._v(" Prijíma leady ")]) : _vm._e()])]), _c('span', {
      staticClass: "client-count"
    }, [_c('strong', [_vm._v(_vm._s(financier.assigned_clients_count || 0))]), _c('small', [_vm._v("klientov")])])]);
  }), !_vm.filteredFinanciers.length ? _c('div', {
    staticClass: "empty-list"
  }, [_vm._v(" Žiadny finančník nezodpovedá filtru. ")]) : _vm._e()], 2)]), _c('section', {
    staticClass: "financier-detail"
  }, [!_vm.form ? _c('div', {
    staticClass: "empty-detail"
  }, [_c('span', {
    staticClass: "empty-detail-icon"
  }, [_vm._v("👤")]), _c('strong', [_vm._v("Vyberte finančníka")]), _c('p', [_vm._v("Vľavo vyberte účet, ktorý chcete skontrolovať alebo upraviť.")]), _c('button', {
    staticClass: "primary-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.startCreating
    }
  }, [_vm._v(" Pridať finančníka ")])]) : [_c('div', {
    staticClass: "detail-heading"
  }, [_c('div', {
    staticClass: "detail-identity"
  }, [_c('span', {
    staticClass: "avatar large",
    style: _vm.formAvatarStyle
  }, [!_vm.formAvatarUrl ? _c('span', [_vm._v(_vm._s(_vm.formInitials))]) : _vm._e()]), _c('div', [_c('div', {
    staticClass: "detail-eyebrow"
  }, [_vm._v(" " + _vm._s(_vm.creating ? "Nový účet" : "Finan\u010Dn\xEDk #".concat(_vm.form.id)) + " ")]), _c('h3', [_vm._v(_vm._s(_vm.formDisplayName))]), _c('span', [_vm._v(_vm._s(_vm.form.email || "Email ešte nie je vyplnený"))])])]), _c('button', {
    staticClass: "close-detail",
    attrs: {
      "type": "button",
      "title": "Zavrieť"
    },
    on: {
      "click": _vm.closeDetail
    }
  }, [_vm._v(" × ")])]), _c('nav', {
    staticClass: "detail-tabs",
    attrs: {
      "aria-label": "Údaje finančníka"
    }
  }, _vm._l(_vm.tabs, function (tab) {
    return _c('button', {
      key: tab.value,
      "class": {
        active: _vm.activeTab === tab.value
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          _vm.activeTab = tab.value;
        }
      }
    }, [_vm._v(" " + _vm._s(tab.label) + " "), tab.value === 'locations' ? _c('span', [_vm._v(_vm._s(_vm.selectedDistrictCount))]) : _vm._e(), tab.value === 'banks' ? _c('span', [_vm._v(_vm._s(_vm.configuredBankCount))]) : _vm._e()]);
  }), 0), _c('form', {
    staticClass: "detail-form",
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.saveFinancier.apply(null, arguments);
      }
    }
  }, [_c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.activeTab === 'account',
      expression: "activeTab === 'account'"
    }],
    staticClass: "form-section"
  }, [_vm._m(1), _c('div', {
    staticClass: "avatar-editor"
  }, [_c('span', {
    staticClass: "avatar xlarge",
    style: _vm.formAvatarStyle
  }, [!_vm.formAvatarUrl ? _c('span', [_vm._v(_vm._s(_vm.formInitials))]) : _vm._e()]), _c('label', {
    staticClass: "file-button"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.selectProfileImage
    }
  }), _vm._v(" Nahrať profilovú fotku ")]), _c('small', [_vm._v("JPG, PNG alebo WebP. Fotka sa odošle až pri uložení.")])]), _c('div', {
    staticClass: "fields-grid three"
  }, [_c('label', {
    staticClass: "form-field compact"
  }, [_c('span', [_vm._v("Titul")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.form.degree,
      expression: "form.degree",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "maxlength": "16",
      "placeholder": "Ing."
    },
    domProps: {
      "value": _vm.form.degree
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "degree", $event.target.value.trim());
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _c('label', {
    staticClass: "form-field"
  }, [_c('span', [_vm._v("Meno *")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.form.first_name,
      expression: "form.first_name",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": _vm.form.first_name
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "first_name", $event.target.value.trim());
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _c('label', {
    staticClass: "form-field"
  }, [_c('span', [_vm._v("Priezvisko *")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.form.last_name,
      expression: "form.last_name",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": _vm.form.last_name
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "last_name", $event.target.value.trim());
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })])]), _c('div', {
    staticClass: "fields-grid two"
  }, [_c('label', {
    staticClass: "form-field"
  }, [_c('span', [_vm._v("Prihlasovací email *")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.form.email,
      expression: "form.email",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "email",
      "required": ""
    },
    domProps: {
      "value": _vm.form.email
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "email", $event.target.value.trim());
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _c('label', {
    staticClass: "form-field"
  }, [_c('span', [_vm._v(_vm._s(_vm.creating ? "Úvodné heslo *" : "Nové heslo"))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.password,
      expression: "form.password"
    }],
    attrs: {
      "type": "password",
      "required": _vm.creating,
      "minlength": "8",
      "autocomplete": "new-password",
      "placeholder": _vm.creating ? 'Minimálne 8 znakov' : 'Nechajte prázdne bez zmeny'
    },
    domProps: {
      "value": _vm.form.password
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "password", $event.target.value);
      }
    }
  })])]), _c('div', {
    staticClass: "switch-grid"
  }, [_c('label', {
    staticClass: "setting-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.is_active,
      expression: "form.is_active"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.is_active) ? _vm._i(_vm.form.is_active, null) > -1 : _vm.form.is_active
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.form.is_active,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.form, "is_active", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.form, "is_active", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.form, "is_active", $$c);
        }
      }
    }
  }), _vm._m(2), _vm._m(3)]), _c('label', {
    staticClass: "setting-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.is_temporary,
      expression: "form.is_temporary"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.is_temporary) ? _vm._i(_vm.form.is_temporary, null) > -1 : _vm.form.is_temporary
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.form.is_temporary,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.form, "is_temporary", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.form, "is_temporary", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.form, "is_temporary", $$c);
        }
      }
    }
  }), _vm._m(4), _vm._m(5)])]), !_vm.creating ? _c('div', {
    staticClass: "read-only-meta"
  }, [_c('div', [_c('span', [_vm._v("Vytvorený")]), _c('strong', [_vm._v(_vm._s(_vm.formatDate(_vm.form.date_joined)))])]), _c('div', [_c('span', [_vm._v("Posledné prihlásenie")]), _c('strong', [_vm._v(_vm._s(_vm.formatDate(_vm.form.last_login) || "Zatiaľ sa neprihlásil"))])]), _vm._m(6)]) : _vm._e()]), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.activeTab === 'profile',
      expression: "activeTab === 'profile'"
    }],
    staticClass: "form-section"
  }, [_vm._m(7), _c('div', {
    staticClass: "fields-grid two"
  }, [_c('label', {
    staticClass: "form-field"
  }, [_c('span', [_vm._v("Samostatný finančný agent")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.profile.sfa,
      expression: "form.profile.sfa"
    }],
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.form.profile, "sfa", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Nevybraný")]), _vm._l(_vm.metadata.sfas, function (sfa) {
    return _c('option', {
      key: sfa.id,
      domProps: {
        "value": sfa.id
      }
    }, [_vm._v(" " + _vm._s(sfa.name) + " · " + _vm._s(sfa.registration_number) + " ")]);
  })], 2)]), _c('label', {
    staticClass: "form-field"
  }, [_c('span', [_vm._v("Telefón")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.form.profile.telephone,
      expression: "form.profile.telephone",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "tel",
      "placeholder": "+421..."
    },
    domProps: {
      "value": _vm.form.profile.telephone
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form.profile, "telephone", $event.target.value.trim());
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })])]), _c('div', {
    staticClass: "fields-grid two"
  }, [_c('label', {
    staticClass: "form-field"
  }, [_c('span', [_vm._v("Číslo registrácie NBS")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.form.profile.cislo_registracie_NBS,
      expression: "form.profile.cislo_registracie_NBS",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.form.profile.cislo_registracie_NBS
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form.profile, "cislo_registracie_NBS", $event.target.value.trim());
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _c('label', {
    staticClass: "form-field"
  }, [_c('span', [_vm._v("Obchodné meno")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.form.profile.obchodne_meno,
      expression: "form.profile.obchodne_meno",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.form.profile.obchodne_meno
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form.profile, "obchodne_meno", $event.target.value.trim());
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })])]), _c('label', {
    staticClass: "form-field"
  }, [_c('span', [_vm._v("Adresa")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.form.profile.adresa,
      expression: "form.profile.adresa",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.form.profile.adresa
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form.profile, "adresa", $event.target.value.trim());
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _c('div', {
    staticClass: "fields-grid two"
  }, [_c('label', {
    staticClass: "form-field"
  }, [_c('span', [_vm._v("IČO")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.form.profile.ico,
      expression: "form.profile.ico",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "maxlength": "20"
    },
    domProps: {
      "value": _vm.form.profile.ico
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form.profile, "ico", $event.target.value.trim());
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _c('label', {
    staticClass: "form-field"
  }, [_c('span', [_vm._v("Kontaktný email")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.form.profile.email,
      expression: "form.profile.email",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "email"
    },
    domProps: {
      "value": _vm.form.profile.email
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form.profile, "email", $event.target.value.trim());
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })])]), _c('label', {
    staticClass: "form-field"
  }, [_c('span', [_vm._v("Fillout ID")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.form.profile.fillout_id,
      expression: "form.profile.fillout_id",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.form.profile.fillout_id
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form.profile, "fillout_id", $event.target.value.trim());
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _c('label', {
    staticClass: "setting-switch featured"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.profile.is_pooled,
      expression: "form.profile.is_pooled"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.profile.is_pooled) ? _vm._i(_vm.form.profile.is_pooled, null) > -1 : _vm.form.profile.is_pooled
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.form.profile.is_pooled,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.form.profile, "is_pooled", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.form.profile, "is_pooled", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.form.profile, "is_pooled", $$c);
        }
      }
    }
  }), _vm._m(8), _vm._m(9)])]), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.activeTab === 'locations',
      expression: "activeTab === 'locations'"
    }],
    staticClass: "form-section locations-section"
  }, [_c('div', {
    staticClass: "form-section-heading"
  }, [_vm._m(10), _c('span', {
    staticClass: "selection-count"
  }, [_vm._v(_vm._s(_vm.selectedDistrictCount) + " vybraných")])]), _vm.selectedDistricts.length ? _c('div', {
    staticClass: "selected-districts"
  }, _vm._l(_vm.selectedDistricts, function (district) {
    return _c('button', {
      key: district.id,
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.toggleDistrict(district.id);
        }
      }
    }, [_vm._v(" " + _vm._s(district.name) + " "), _c('span', [_vm._v("×")])]);
  }), 0) : _vm._e(), _c('label', {
    staticClass: "district-search"
  }, [_c('span', [_vm._v("Filtrovať okresy")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.districtSearch,
      expression: "districtSearch",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "search",
      "placeholder": "Napr. Bratislava, Nitra..."
    },
    domProps: {
      "value": _vm.districtSearch
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.districtSearch = $event.target.value.trim();
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _c('div', {
    staticClass: "district-groups"
  }, _vm._l(_vm.districtGroups, function (group) {
    return _c('section', {
      key: group.name
    }, [_c('div', {
      staticClass: "district-group-heading"
    }, [_c('strong', [_vm._v(_vm._s(group.name || "Bez kraja"))]), _c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.toggleDistrictGroup(group);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.isDistrictGroupSelected(group) ? "Zrušiť kraj" : "Vybrať kraj") + " ")])]), _c('div', {
      staticClass: "district-options"
    }, _vm._l(group.districts, function (district) {
      return _c('label', {
        key: district.id
      }, [_c('input', {
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": _vm.form.profile.districts_served.includes(district.id)
        },
        on: {
          "change": function change($event) {
            return _vm.toggleDistrict(district.id);
          }
        }
      }), _c('span', [_vm._v(_vm._s(district.name))])]);
    }), 0)]);
  }), 0)]), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.activeTab === 'banks',
      expression: "activeTab === 'banks'"
    }],
    staticClass: "form-section banks-section"
  }, [_vm._m(11), _c('div', {
    staticClass: "security-note"
  }, [_vm._v(" Heslá sa nikdy nenačítavajú späť. Nové heslo zadajte iba vtedy, keď ho chcete zmeniť. ")]), _c('div', {
    staticClass: "bank-editors"
  }, _vm._l(_vm.form.bank_data, function (bankData) {
    return _c('details', {
      key: bankData.bank,
      attrs: {
        "open": bankData.bank === _vm.firstConfiguredBankId
      }
    }, [_c('summary', [_c('span', {
      staticClass: "bank-code"
    }, [_vm._v(_vm._s(_vm.bankMonogram(bankData.bank_name)))]), _c('span', [_c('strong', [_vm._v(_vm._s(bankData.bank_name))]), _c('small', [_vm._v(_vm._s(_vm.bankConfigurationLabel(bankData)))])]), _vm.isBankConfigured(bankData) ? _c('em', [_vm._v("Nastavené")]) : _vm._e()]), _c('div', {
      staticClass: "bank-fields"
    }, [_c('div', {
      staticClass: "fields-grid two"
    }, [_c('label', {
      staticClass: "form-field"
    }, [_c('span', [_vm._v("ID obchodníka")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.trim",
        value: bankData.id_obchodnika,
        expression: "bankData.id_obchodnika",
        modifiers: {
          "trim": true
        }
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": bankData.id_obchodnika
      },
      on: {
        "input": function input($event) {
          if ($event.target.composing) return;
          _vm.$set(bankData, "id_obchodnika", $event.target.value.trim());
        },
        "blur": function blur($event) {
          return _vm.$forceUpdate();
        }
      }
    })]), _c('label', {
      staticClass: "form-field"
    }, [_c('span', [_vm._v("Portálové meno")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.trim",
        value: bankData.portal_meno,
        expression: "bankData.portal_meno",
        modifiers: {
          "trim": true
        }
      }],
      attrs: {
        "type": "text",
        "autocomplete": "off"
      },
      domProps: {
        "value": bankData.portal_meno
      },
      on: {
        "input": function input($event) {
          if ($event.target.composing) return;
          _vm.$set(bankData, "portal_meno", $event.target.value.trim());
        },
        "blur": function blur($event) {
          return _vm.$forceUpdate();
        }
      }
    })])]), _c('div', {
      staticClass: "fields-grid two"
    }, [_c('label', {
      staticClass: "form-field"
    }, [_c('span', [_vm._v("Nové portálové heslo")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: bankData.new_portal_password,
        expression: "bankData.new_portal_password"
      }],
      attrs: {
        "type": "password",
        "autocomplete": "new-password",
        "placeholder": bankData.portal_password_is_set ? 'Heslo je uložené' : 'Nie je nastavené'
      },
      domProps: {
        "value": bankData.new_portal_password
      },
      on: {
        "input": function input($event) {
          if ($event.target.composing) return;
          _vm.$set(bankData, "new_portal_password", $event.target.value);
        }
      }
    })]), _c('label', {
      staticClass: "form-field"
    }, [_c('span', [_vm._v("Koeficient odmeny (%)")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: bankData.koeficient_odmeny,
        expression: "bankData.koeficient_odmeny"
      }],
      attrs: {
        "type": "number",
        "min": "0",
        "max": "999.99",
        "step": "0.01"
      },
      domProps: {
        "value": bankData.koeficient_odmeny
      },
      on: {
        "input": function input($event) {
          if ($event.target.composing) return;
          _vm.$set(bankData, "koeficient_odmeny", $event.target.value);
        }
      }
    })])]), bankData.portal_password_is_set ? _c('label', {
      staticClass: "clear-password"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: bankData.clear_portal_password,
        expression: "bankData.clear_portal_password"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(bankData.clear_portal_password) ? _vm._i(bankData.clear_portal_password, null) > -1 : bankData.clear_portal_password
      },
      on: {
        "change": function change($event) {
          var $$a = bankData.clear_portal_password,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && _vm.$set(bankData, "clear_portal_password", $$a.concat([$$v]));
            } else {
              $$i > -1 && _vm.$set(bankData, "clear_portal_password", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
            }
          } else {
            _vm.$set(bankData, "clear_portal_password", $$c);
          }
        }
      }
    }), _vm._v(" Vymazať uložené portálové heslo ")]) : _vm._e()])]);
  }), 0)]), _vm.formError ? _c('div', {
    staticClass: "form-error"
  }, [_vm._v(_vm._s(_vm.formError))]) : _vm._e(), _c('footer', {
    staticClass: "detail-footer"
  }, [_c('button', {
    staticClass: "secondary-button",
    attrs: {
      "type": "button",
      "disabled": _vm.saving
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v(" " + _vm._s(_vm.creating ? "Vymazať formulár" : "Zahodiť zmeny") + " ")]), _c('button', {
    staticClass: "primary-button",
    attrs: {
      "type": "submit",
      "disabled": _vm.saving
    }
  }, [_vm._v(" " + _vm._s(_vm.saving ? "Ukladám..." : _vm.creating ? "Založiť finančníka" : "Uložiť finančníka") + " ")])])])]], 2)])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "section-kicker"
  }, [_vm._v("Používatelia")]), _c('h2', [_vm._v("Finančníci")]), _c('p', [_vm._v("Účty, kontaktné údaje, lokality a prístupy do bankových portálov.")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "form-section-heading"
  }, [_c('div', [_c('h4', [_vm._v("Účet a osobné údaje")]), _c('p', [_vm._v("Základné údaje používané na prihlásenie a zobrazenie v Brokeri.")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', {
    staticClass: "switch-track"
  }, [_c('span')]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', [_c('strong', [_vm._v("Aktívny účet")]), _c('small', [_vm._v("Finančník sa môže prihlásiť do aplikácie.")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', {
    staticClass: "switch-track"
  }, [_c('span')]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', [_c('strong', [_vm._v("Dočasný účet")]), _c('small', [_vm._v("Označenie používané administráciou.")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('span', [_vm._v("Rola")]), _c('strong', [_vm._v("Finančník")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "form-section-heading"
  }, [_c('div', [_c('h4', [_vm._v("Profil finančníka")]), _c('p', [_vm._v("Údaje používané v dokumentoch, kontakte s klientom a automatizáciách.")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', {
    staticClass: "switch-track"
  }, [_c('span')]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', [_c('strong', [_vm._v("Automatické prideľovanie leadov")]), _c('small', [_vm._v(" Aktívny finančník môže prijímať nových klientov z vybraných lokalít. ")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('h4', [_vm._v("Obsluhované lokality")]), _c('p', [_vm._v("Okresy sa používajú pri automatickom prideľovaní nových leadov.")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "form-section-heading"
  }, [_c('div', [_c('h4', [_vm._v("Bankové údaje")]), _c('p', [_vm._v("ID obchodníka, portálové meno a koeficient odmeny pre jednotlivé banky.")])])]);

}]

export { render, staticRenderFns }